import { navigateToListingUrl } from "../utils/listing-url";
import ActiveFilterChip from "./ActiveFilterChip";
import clsx from "clsx";
import React from "react";
/**
 * Renders removable filter chips and a "Wyczyść filtry" link.
 * Returns null when there are no active chips.
 * Pass className to control the container layout (e.g. flex-wrap vs horizontal scroll).
 */
export default function ActiveFiltersChipBar({ chips, clearAllUrl, className, }) {
    if (chips.length === 0)
        return null;
    return (<div className={clsx("flex items-center gap-2", className)}>
      {chips.map((chip) => (<ActiveFilterChip key={`${chip.key}:${chip.value}`} label={chip.valueLabel} removeUrl={chip.removeUrl}/>))}
      <button type="button" onClick={() => navigateToListingUrl(clearAllUrl)} className="shrink-0 inline-flex items-center h-10 lg:h-8 px-3 text-[#0071CE] text-sm font-semibold whitespace-nowrap bg-transparent border-0 cursor-pointer">
        Wyczyść filtry
      </button>
    </div>);
}
